import React from 'react';
import { bool, func, number, oneOfType, string } from 'prop-types';

import catGroups from 'data/categoryGroups';
import AlternateSecondPage from './AlternateSecondPage';
import FirstPageContainer from './FirstPageContainer';
import SecondPageContainer from './SecondPageContainer';
import ThirdPageContainer from './ThirdPageContainer';
import NotFoundPage from './NotFoundPage';
import WrapUpPage from './WrapUpPage';

import { handlePageChange } from './utils';

export default function PartnerSubmissionForm({
  activePage,
  experienced,
  handleSubmit,
  nextPage,
  previousPage,
  setPage
}) {
  const handleBackClick = (pageNum) => () => setPage(pageNum);
  const notFoundPage = (
    <NotFoundPage setPage={handlePageChange(handleBackClick(1))} />
  );

  const secondPage = () => {
    switch (experienced) {
      case true:
        return (
          <SecondPageContainer
            categoryGroups={catGroups}
            nextPage={handlePageChange(nextPage)}
            previousPage={handlePageChange(previousPage)}
          />
        );
      case false:
        return (
          <AlternateSecondPage
            onSubmit={handleSubmit}
            previousPage={handlePageChange(previousPage)}
          />
        );
      default:
        return notFoundPage;
    }
  };

  const currentPage = () => {
    switch (activePage) {
      case 1:
        return <FirstPageContainer nextPage={handlePageChange(nextPage)} />;
      case 2:
        return secondPage();
      case 3:
        return (
          <ThirdPageContainer
            categoryGroups={catGroups}
            handleSubmit={handleSubmit}
            previousPage={handlePageChange(previousPage)}
          />
        );
      case 4:
        return <WrapUpPage />;
      default:
        return notFoundPage;
    }
  };

  return (
    <section className="partner-contact-form" id="partner-contact-form">
      {currentPage()}
    </section>
  );
}

PartnerSubmissionForm.propTypes = {
  activePage: number.isRequired,
  experienced: oneOfType([bool, string]),
  handleSubmit: func.isRequired,
  nextPage: func.isRequired,
  previousPage: func.isRequired,
  setPage: func.isRequired
};

PartnerSubmissionForm.defaultProps = {
  experienced: false
};
